import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import $ from "jquery";
import PropTypes from "prop-types";

import {createFakeLayout, getCurrentLayout} from "../../appLayout";
import LoadingSpinner from "../../ui/loadingSpinner";
import ActionTypes from "../../../misc/actionTypes";
import {loaderDisable, loaderEnable} from "../../ui/loaderView";
import {getImagePromiseFromLayout} from "../../../misc/getCanvasImageFromLayout";
import {useIsMounted} from "../../../misc/helperHooks";

const RoomSceneNavigationItem = (props) => {

  const {roomScene, isActive, setActiveScene} = props;

  const [thumbnailUrl, setThumbnailUrl] = useState();
  const layout = getCurrentLayout();
  const isMounted = useIsMounted();

  useEffect(() => {
    if (!thumbnailUrl) {
      const getLayoutThumbnail = async () => {
        const fakeLayout = layout.scene === roomScene ? layout : createFakeLayout();
        if (!isActive) {
          await fakeLayout.selectLayout(layout.type, null, null, roomScene, null, true);
        }
        // console.log("layout.getLayers(showPlaceHolders)", roomScene, fakeLayout, fakeLayout.getLayers(false));
        const imageResponse = await getImagePromiseFromLayout(fakeLayout);
        if (isMounted() && imageResponse) {
          setThumbnailUrl(imageResponse);
        }

      }
      getLayoutThumbnail();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const roomSceneClick = async () => {
    if (!isActive) {
      loaderEnable();
      setActiveScene(roomScene);
      await layout.selectLayout(layout.type, null, null, roomScene);
      $(window).trigger(ActionTypes.UPDATE_ALL_ITEMS); // update canvas
      loaderDisable();
    }
  };

  return (
    <li className={"layout-list__item" + (isActive ? " active" : "")}
        data-index={roomScene}
        onClick={() => roomSceneClick(roomScene)}
        style={{backgroundImage: `url(${thumbnailUrl})`}}>
      {thumbnailUrl ? null : <LoadingSpinner/>}
    </li>
  )
};

RoomSceneNavigationItem.propTypes = {
  roomScene: PropTypes.string.isRequired,
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RoomSceneNavigationItem)
